import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslationService } from '../../../services/translation.service';
import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { PdfViewerService } from '../../../services/pdf-viewer.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-top-navbar',
  imports: [RouterLink, ...MATERIAL_IMPORTS, ...TRANSLATIONS_IMPORTS],
  templateUrl: './top-navbar.html',
  styleUrl: './top-navbar.scss',
})
export class TopNavbar {
  private readonly router = inject(Router);
  public readonly translationService = inject(TranslationService);
  private readonly pdfPreview = inject(PdfViewerService);

  showFloatingNavbar = false;
  currentSection: string = 'home';

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const sections = ['home', 'about', 'documents', 'faqs'];
    this.showFloatingNavbar = window.scrollY > 120;
    const scrollPos = window.scrollY + 120;

    for (const sectionId of sections) {
      const section = document.getElementById(sectionId);
      if (section) {
        const top = section.offsetTop;
        const bottom = top + section.offsetHeight;
        if (scrollPos >= top && scrollPos < bottom) {
          this.currentSection = sectionId;
        }
      }
    }
  }

  previewDoc() {
    this.pdfPreview.open({
      src: `${environment.AUTH_SERVER_URL}/mel_media/2026/03/sw-1752762713-dira-ya-taifa-ya-maendeleo-2050-dd3848c5.pdf`,
      filename: 'Dira 2050',
      showPrint: true,
      showDownload: true,
    });
  }

  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.currentSection = sectionId;
    }
  }

  goToLogin() {
    this.router.navigate(['', 'login']);
  }
}
